const l = (d) => {
  console.log(d)
  return d
}

class Fletch {
  constructor(props) {
    this.defaults = {}
    if (props.root) {
      this.defaults.root = props.root
    }
    this.send = this.send.bind(this)
    this.post = this.post.bind(this)
    this.get = this.get.bind(this)
    this.put = this.put.bind(this)
  }

  send(uri, config) {
    let url = uri
    if (this.defaults && this.defaults.root) {
      url = `${this.defaults.root}${uri}`
    }
    const fetchConfig = config
    if (!fetchConfig.headers) {
      const headers = new Headers()
      headers.append('Content-Type', 'application/json')
      headers.append('Accept', 'application/json')
      fetchConfig.headers = headers
    }

    return fetch(url, fetchConfig)
      .then(res => res.json().then(data => ({
        data,
        headers: res.headers,
        ok: res.ok,
      })))
      .then((response) => {
        if (!response.ok) {
          return Promise.reject(response)
        }
        return response
      })
      .catch(err => Promise.reject(err))
  }

  get(uri, params = '') {
    const config = {
      method: 'GET',
    }
    return this.send(uri, config)
  }

  post(uri, params) {
    const config = {
      method: 'POST',
      body: JSON.stringify(params),
    }
    return this.send(uri, config)
  }

  put(uri, params) {
    const config = {
      method: 'PUT',
      body: JSON.stringify(params),
    }

    return this.send(uri, config)
  }

  delete(uri, params) {
    const config = {
      method: 'DELETE',
      body: JSON.stringify(params),
    }

    return this.send(uri, config)
  }
}

export default Fletch
